var $67fbf548bee75f33$exports = {};
$67fbf548bee75f33$exports = {
    "breadcrumbs": `Navigacijski putovi`
};


export {$67fbf548bee75f33$exports as default};
//# sourceMappingURL=hr-HR.mjs.map
